import { createStore, applyMiddleware, combineReducers } from 'redux';
import initalReducers from './../reducers';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createTracker } from 'redux-segment';
import { apiMiddleware } from 'redux-api-middleware';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import get from 'lodash/get';

import { showLoading } from 'react-redux-loading-bar';

import { LOCATION_CHANGE } from 'connected-react-router';

import { cartTrackMappings } from '../ducks/cart';

const customTrackingMapper = {
  mapper: {
    ...cartTrackMappings
  }
};

const loadingBarMiddleware = store => next => action => {
  if (action.type === LOCATION_CHANGE) {
    // action.payload.location.pathname will be set if this is a change in path
    // otherwise it won't be present, only show loader when changing path.
    const { router } = store.getState();
    if (
      !(
        get(router, 'location.pathname') ===
          get(action, 'payload.location.pathname') &&
        get(router, 'location.search') ===
          get(action, 'payload.location.search')
      )
    ) {
      next(action);
      return store.dispatch(showLoading());
    }
  }

  next(action);
};

const createReducer = (
  staticReducers,
  connectedRouter = null,
  asyncReducers = {}
) => {
  const reducers = {};
  if (connectedRouter) {
    reducers.router = connectedRouter;
  }

  return combineReducers({
    ...reducers,
    ...staticReducers,
    ...asyncReducers
  });
};

export const configureCMSStore = () => {
  const tracker = createTracker(customTrackingMapper);

  const store = createStore(
    createReducer(initalReducers),
    composeWithDevTools(
      applyMiddleware(thunk, apiMiddleware, loadingBarMiddleware, tracker)
    )
  );

  store.asyncReducers = {};

  store.injectReducer = (key, asyncReducer) => {
    store.asyncReducers[key] = asyncReducer;
    store.replaceReducer(
      createReducer(initalReducers, null, store.asyncReducers)
    );
  };

  return store;
};

const configureStore = (history, preloadedState) => {
  const tracker = createTracker(customTrackingMapper);
  const connectedRouter = connectRouter(history);

  // SSR router is not keeping the actual state
  delete preloadedState.router;

  const store = createStore(
    createReducer(initalReducers, connectedRouter),
    preloadedState,
    composeWithDevTools(
      applyMiddleware(
        thunk,
        apiMiddleware,
        loadingBarMiddleware,
        routerMiddleware(history), // for dispatching history actions
        tracker
      )
    )
  );

  store.asyncReducers = {};

  store.injectReducer = (key, asyncReducer) => {
    store.asyncReducers[key] = asyncReducer;
    store.replaceReducer(
      createReducer(initalReducers, connectedRouter, store.asyncReducers)
    );
  };

  return store;
};

export default configureStore;
